import { render, staticRenderFns } from "./ExportRequestsGrid.vue?vue&type=template&id=736ae57c&scoped=true&"
import script from "./ExportRequestsGrid.vue?vue&type=script&lang=ts&"
export * from "./ExportRequestsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ExportRequestsGrid.vue?vue&type=style&index=0&id=736ae57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ae57c",
  null
  
)

export default component.exports